import React, { useRef, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _get from 'lodash/get';



const CopyInput = forwardRef((props, ref) => {

    const {
        icon,
        value,
        resetTimeout,
        ariaLabel,
        trackingConfig,
        dictionary,
    } = props;
    const input = useRef(null);
    const [
        copied,
        setCopied,
    ] = useState(false);

    const {
        dataType,
        handler,
    } = trackingConfig;

    const reset = () => {

        setCopied(false);

    };

    const selectAndCopy = () => {
        input.current.select();
        document.execCommand('copy');
        setCopied(true);
        setTimeout(reset, resetTimeout);

        if (handler) {
            handler(input);
        }
    };

    const copyBtnClassNames = classNames(
        'copy-input__copy-button',
        {
            'copy-input__copy-button--copied': copied,
        });

    const buttonText = copied ? _get(dictionary, 'copied_text', 'Copied') : _get(dictionary, 'copy_text', 'Copy');

    return (
        <div onClick={() => selectAndCopy()} className="copy-input">
            {icon ? (<img className="copy-input__icon" src={ icon } />) : null}
            <input ref={input} className="copy-input__input" type="text" defaultValue={value} onBlur={() => reset()} readOnly data-type={dataType} />
            <button
                className={copyBtnClassNames}
                role="button"
                aria-pressed={copied}
                aria-label={ariaLabel}
                ref={ref}
            >
                {buttonText}
            </button>
        </div>
    );

});

CopyInput.propTypes = {
    icon: PropTypes.string,
    value: PropTypes.string,
    resetTimeout: PropTypes.number,
    ariaLabel: PropTypes.string,
    trackingConfig: PropTypes.shape({
        dataType: PropTypes.string,
        handler: PropTypes.func
    }),
    dictionary:  PropTypes.object,
};

CopyInput.defaultProps = {
    icon: '',
    value: '',
    resetTimeout: 1500,
    ariaLabel: 'Copy button',
    trackingConfig: {
        dataType: '',
        handler: undefined
    },
    dictionary: {},
};

export default CopyInput;
